import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('../container/main.vue'),
        children: [
            {
                path: '/',
                component: () => import('../container/home/index.vue')
            },
            {
                path: '/chou_jiang',
                component: () => import('../container/home/choujiang.vue')
            },
            {
                path: '/gui_ze',
                component: () => import('../container/gui_ze/index.vue')
            },
            {
                path: '/chou_jiang_ji_lu',
                component: () => import('../container/chou_jiang_ji_lu/index.vue')
            },
            {
                path: '/yao_qing_ji_lu',
                component: () => import('../container/yao_qing_ji_lu/index.vue')
            },
            {
                path: '/chou_jiang',
                component: () => import('../container/chou_jiang/index.vue')
            }
            
        ]
    }
]

const router = new VueRouter({
    routes
})


export default router